import * as React from 'react';
import { Component } from 'react';
import { IRegisterModel } from '../../models/IRegisterModel';
import './LogIn.css';
import { DEFAULT_STATUS_TIMEOUT } from '../../constants/SystemConsts';
import { LoaderComponent } from '../../controls/Loader';
import { CheckBoxComponent } from '../../controls/CheckBox';
import { StatuteComponent } from '../Statute/Statute';
import { ShowStatusBar } from '../Layout/GlobalStatusBar';
import { IdentityService } from '../../services/IdentityService';
import Footer from './Footer';
import { ImageContainer } from './ImageContainer';
import { FormGroup } from '../../controls/Form/FormGroup';
import { IRegisterResult } from '../../models/IRegisterResult';
import { PasswordHelpBlock } from './PasswordHelpBlock';
import {
    GetPasswordValidationState,
    GetConfirmPassowrdValidationState,
    GetProfessionNumberValidationState,
    fullValidation
} from './PasswordValidation';
import { IRetryEmailValidation } from '../../models/IRetryEmailValidation';
import { SimpleSelectComponent } from "src/controls/SimpleSelect";
import { IDropDownItem } from "src/models/IDropdownItem";

interface IState extends IRegisterModel {
    TestValue: string,
    IsFormPristine: boolean,
    LoaderVisible: boolean,
    AgreementsAccepted: boolean,
    StatuteVisible: boolean,
    ObfuscatedEmail: string,
    RetryToken: string;
    RegisterFinished: boolean;
    DidSubmit: boolean;
}

const Months: IDropDownItem[] = [
    { Id: 0, Value: "styczeń" },
    { Id: 1, Value: "luty" },
    { Id: 2, Value: "marzec" },
    { Id: 3, Value: "kwiecień" },
    { Id: 4, Value: "maj" },
    { Id: 5, Value: "czerwiec" },
    { Id: 6, Value: "lipiec" },
    { Id: 7, Value: "sierpień" },
    { Id: 8, Value: "wrzesień" },
    { Id: 9, Value: "październik" },
    { Id: 10, Value: "listopad" },
    { Id: 11, Value: "grudzień" },
]

class RegisterComponent extends Component<any, IState> {

    private didSubmit = false;

    constructor(props) {
        super(props);

        let professionNumber = this.props.match.params.professionNumber;
        this.state = {
            ProfessionNumber: professionNumber ? professionNumber : '',
            Password: '',
            ConfirmPassword: '',
            TestValue: '',
            IsFormPristine: true,
            LoaderVisible: false,
            AgreementsAccepted: false,
            StatuteVisible: false,
            ObfuscatedEmail: "",
            RetryToken: "",
            RegisterFinished: false,
            DidSubmit: false,
        };
    }


    public render() {
        const { LoaderVisible, IsFormPristine, ProfessionNumber, Password, ConfirmPassword, AgreementsAccepted, RegisterFinished, ObfuscatedEmail, BirthDateDay, BirthDateMonth, BirthDateYear } = this.state;
        return (
            <div className="login-component route-component form-component">
                {this.RenderStatute()}
                <div className="content-container">
                    <div className="content">
                        <LoaderComponent Visible={LoaderVisible} />
                        <div className="form-container">
                            <div className="form-container__wrapper">
                                <div className="kif-logo" />
                                {RegisterFinished ?
                                    <>
                                        <div className="header">
                                            <h3>Utwórz konto w KIF</h3>
                                            <span className="sub-header">Wysłaliśmy link aktywacyjny na maila <b>{ObfuscatedEmail}</b></span>
                                            <br />
                                            <br />
                                            <br />
                                            <span className="sub-header">Przejdź do swojej poczty i kliknij w link w mailu aby ukończyć tworzenie konta.</span>
                                        </div>
                                        <div className="submit-success-container">
                                            <div className="success-image" />
                                            <span>Nie otrzymałeś maila?</span>
                                            <span className="bottom-redirect"><a onClick={this.Send}>Wyślij ponownie</a></span>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className="header">
                                            <h3>Zarejestruj się w KIF</h3>
                                        </div>
                                        <form onSubmit={this.OnFormSubmit} className={IsFormPristine ? 'pristine' : ''}>
                                            <FormGroup
                                                Name="ProfessionNumber"
                                                OnChange={this.OnInputChange}
                                                Label="Numer PWZFz"
                                                Value={ProfessionNumber}
                                                ValidationState={this.GetProfessionNumberValidationStateHandler}
                                                ErrorBlock="Proszę podać swój numer prawa wykonywania zawodu fizjoterapeuty"
                                            />
                                            <FormGroup
                                                Type="text"
                                                Label="Data urodzenia"
                                                ValidationState={this.GetBirthDateValidation}
                                                ErrorBlock="Podaj datę urodzenia">
                                                <div className={`date-form ${this.GetBirthDateValidation() === "error" ? "date-form--error" : ""}`}>
                                                    <input placeholder="01" onChange={this.OnInputChange} name="BirthDateDay" type="number" className={`date-input date-input--day ${this.GetBirthDateValidation() === "error" ? "date-input--error" : ""}`} value={BirthDateDay} />
                                                    <SimpleSelectComponent
                                                        NoAvatar={true}
                                                        Items={Months}
                                                        OnItemSelected={this.SelectMonth}
                                                        Title={BirthDateMonth ? BirthDateMonth.Value : Months[0].Value}
                                                    />
                                                    <input placeholder="1980" onChange={this.OnInputChange} name="BirthDateYear" type="number" className={`date-input date-input--year ${this.GetBirthDateValidation() === "error" ? "date-input--error" : ""}`} value={BirthDateYear} />
                                                </div>
                                            </FormGroup>
                                            <FormGroup
                                                Name="Password"
                                                OnChange={this.OnInputChange}
                                                Label="Hasło"
                                                Value={Password}
                                                Type="password"
                                                ClassName="form-group--no-margin"
                                                ValidationState={this.GetPasswordValidationStateHandler}
                                                ErrorBlock="Hasło musi zawierać conajmniej 8 znaków"
                                            />
                                            <PasswordHelpBlock Password={Password} />
                                            <FormGroup
                                                Name="ConfirmPassword"
                                                OnChange={this.OnInputChange}
                                                Label="Powtórz hasło"
                                                Value={ConfirmPassword}
                                                Type="password"
                                                ClassName="form-group--no-margin"
                                                ValidationState={this.GetConfirmPassowrdValidationStateHandler}
                                                ErrorBlock="Wpisane hasło jest nieprawidłowe"
                                            />

                                            <div className="terms-and-agreements">
                                                <CheckBoxComponent
                                                    Checked={AgreementsAccepted}
                                                    Label={
                                                        <span className="agreements">
                                                            Akceptuję <a href="/docs/regulamin_logowania_SSO.pdf" target="_blank">Regulamin</a> platformy SSO oraz <a href="/policy" target="_blank">Politykę prywatności</a>
                                                        </span>
                                                    }
                                                    OnClick={this.OnAgreementsCheckboxChange}
                                                />
                                                <span className={`help-block ${(!this.didSubmit || AgreementsAccepted) ? "help-block--hidden" : ""}`}>Wymagana jest apkceptacja regulaminu</span>
                                            </div>
                                            <div className="form-buttons">
                                                <input type="submit" className="confirm-button-orange" value="Zarejestruj się" />
                                            </div>
                                        </form>
                                        <span className="bottom-redirect">Masz już konto? <a onClick={this.RedirectToLogIn}>Zaloguj się.</a></span>
                                    </>
                                }
                            </div>
                        </div>
                        <ImageContainer />
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }

    private SelectMonth = (value) => {
        this.setState({
            BirthDateMonth: value
        });
    }

    private RenderStatute = () => {
        if (this.state.StatuteVisible) {
            return (
                <StatuteComponent OnAbort={this.OnStatuteAbort} OnAccept={this.OnStatuteAccept} />
            );
        } else {
            return null;
        }
    }

    private GetProfessionNumberValidationStateHandler = (): 'success' | 'warning' | 'error' | undefined => {
        return GetProfessionNumberValidationState(this.didSubmit, this.state.ProfessionNumber);
    }

    private GetPasswordValidationStateHandler = (): 'success' | 'warning' | 'error' | undefined => {
        return GetPasswordValidationState(this.didSubmit, this.state.Password);
    }

    private GetConfirmPassowrdValidationStateHandler = (): 'success' | 'warning' | 'error' | undefined => {
        return GetConfirmPassowrdValidationState(this.didSubmit, this.state.Password, this.state.ConfirmPassword);
    }

    private GetBirthDateValidation = (): 'success' | 'warning' | 'error' | undefined => {
        if (this.didSubmit) {
            return (this.state.BirthDateDay && this.state.BirthDateMonth && this.state.BirthDateYear) ? "success" : "error";
        }
        return undefined;
    }

    private OnInputChange = (event) => {
        let partialState = {};
        partialState[event.target.name] = event.target.value;
        this.setState({
            ...partialState,
            IsFormPristine: false
        });
    }

    private OnFormSubmit = (event): void => {
        this.didSubmit = true;
        const { Password, ConfirmPassword, ProfessionNumber, AgreementsAccepted, BirthDateDay, BirthDateMonth, BirthDateYear } = this.state;
        if (fullValidation(Password, this.didSubmit, ConfirmPassword, ProfessionNumber) &&
            AgreementsAccepted === true &&
            this.GetBirthDateValidation() === "success"
        ) {
            let service = new IdentityService();
            let data: IRegisterModel = {
                ConfirmPassword,
                ProfessionNumber,
                Password,
                BirthDate: `${BirthDateDay}/${BirthDateMonth && BirthDateMonth.Id ? BirthDateMonth.Id + 1 : 1}/${BirthDateYear}`
            }
            this.setState({
                LoaderVisible: true
            });
            service.Register(data, this.OnRegisterSuccess, this.OnRegisterError);
        } else {
            ShowStatusBar('Error', 'Proszę sprawdzić poprawność formularza', DEFAULT_STATUS_TIMEOUT);
            this.setState({}); //Triggers validation feedback info
        }
        event.preventDefault();
    }

    private OnRegisterSuccess = (result: IRegisterResult) => {
        this.setState({
            ObfuscatedEmail: result.obfuscatedEmail,
            RetryToken: result.retryToken,
            RegisterFinished: true,
            LoaderVisible: false
        });
    }

    private OnRegisterError = (status: number, result: IRegisterResult) => {
        let message: string = "Nie udało się zarejestrować. Sprawdź poprawność formularza i spróbuj ponownie";
        if (result !== null) {
            if (result.status === "exists") {
                message = "Nie udało się zarejestrować. Konto już istnieje.";
            } else if (result.status === "toconfirm") {
                message = `Nie udało się zarejestrować. Konto już istnieje ale jest nieaktywne. Sprawdz email ${result.obfuscatedEmail}.`;
            } else if (result.status === "notfound") {
                message = "Nie udało się zarejestrować. Nie posiadasz prawidłowego adresu email w głownej bazie KIF.";
            } else if (result.status === "error" && result.message !== '') {
                message = `Nie udało się zarejestrować. ${result.message}`;
            }
        }

        this.setState({
            RetryToken: '',
            ObfuscatedEmail: ''
        });

        ShowStatusBar(
            "Error",
            message,
            DEFAULT_STATUS_TIMEOUT);

        this.setState({
            LoaderVisible: false
        });
    }

    private RedirectToLogIn = (evt) => {
        this.props.history.push('/');
    }

    private OnAgreementsCheckboxChange = (e) => {
        e.stopPropagation();
        this.setState({
            AgreementsAccepted: !this.state.AgreementsAccepted
        });
    }

    private OnStatuteAccept = () => {
        this.setState({
            StatuteVisible: false,
            AgreementsAccepted: true
        });
    }

    private OnStatuteAbort = () => {
        this.setState({
            StatuteVisible: false
        });
    }

    private Send = (evt) => {
        let service: IdentityService = new IdentityService();
        service.ResendEmailVerification({ token: this.state.RetryToken } as IRetryEmailValidation, this.OnRegenerateSuccess, this.OnRegenerateError);
    }

    private OnRegenerateSuccess = (result) => {
        ShowStatusBar('Success', 'Link aktywacyjny został wysłany', DEFAULT_STATUS_TIMEOUT);
    }

    private OnRegenerateError = (error: any) => {
        let message: string = 'Nie udało się wysłać ponownie linku aktywacyjnego, nie znaleziono konta.';
        if (error.response.data === "exists") {
            message = 'Nie udało się wysłać ponownie linku aktywacyjnego, konto jest już aktywne.';
        }

        ShowStatusBar('Error', message, DEFAULT_STATUS_TIMEOUT);
    }
}

export default RegisterComponent;


// WEBPACK FOOTER //
// ./src/components/Login/Register.tsx